import { render } from "./ImageDisplay.vue?vue&type=template&id=424b931a"
import script from "./ImageDisplay.vue?vue&type=script&lang=js"
export * from "./ImageDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__